module.exports = __webpack_public_path__ + "img/chuzhi.89291852.svg";